import Academic from './components/Academic';
import Professional from './components/Professional';
import Projects from './components/Projects';
import Personal from './components/Personal';
interface RegistryEntry {
  component: React.ComponentType<any>;
  'group-definition-texture': string;
  xTranslate?: number;
  yTranslate?: number;
  scale?: number;
}

interface Registry {
  [key: string]: RegistryEntry;
}

var registry: Registry = {
  'academic': {'component': Academic, 'group-definition-texture': "/textures/red_wool.png"},
  'professional': {'component': Professional, 'group-definition-texture': "/textures/blue_wool.png"},
  'projects': {'component': Projects, 'group-definition-texture': "/textures/green_wool.png"},
  'personal': {'component': Personal, 'group-definition-texture': "/textures/yellow_wool.png"}
};

export {registry};